import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { DensitiesFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class DensitiesFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.DENSITIES;
	public isMultiSelect = true;
	private static instance: DensitiesFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: DensitiesFilterValue.FULL_TIME, virtualPath: 'full-time', name: 'Full-time' },
		{ id: DensitiesFilterValue.PART_TIME, virtualPath: 'part-time', name: 'Part-time' },
	];

	public static getInstance(): DensitiesFilterMapper {
		if (!DensitiesFilterMapper.instance) {
			DensitiesFilterMapper.instance = new DensitiesFilterMapper();
		}
		return DensitiesFilterMapper.instance;
	}

	private constructor() {
		super();
	}
}
